import axios from './base';

export const getUserListApi = () => {
  return axios.get('/survey/getBannerData');
};

// 部门
export const getDeptTree = () => {
  return axios.get('/dept/treeQuery');
};
export const addDept = (data) => {
  return axios.post('/dept/add', data);
};
export const delDept = (data) => {
  return axios.post('/dept/delete', data);
};
export const updateDept = (data) => {
  return axios.post('/dept/update', data);
};

// 用户列表
export const getUserList = (data) => {
  return axios.post('/user/query', data);
};
export const addUser = (data) => {
  return axios.post('/user/add', data);
};
export const updateUser = (data) => {
  return axios.post('/user/update', data);
};
export const delUser = (data) => {
  return axios.post('/user/delete', data);
};
export const resetPassword = (data) => {
  return axios.post('/user/resetPassword', data);
}

/**
 * 获取本部门调查员
 */
export const getOfficer = (officerName) => {
  return axios.get('/user/getOfficer', { params: { userName: officerName } });
};


// 获取注册用户列表
export const registerUserList = (data) => {
  return axios.post('/register/query', data);
} 
export const approval = (data) => {
  return axios.post('/register/approval', data);
} 
export const reject = (data) => {
  return axios.post('/register/reject', data);
} 